export default "__VITE_ASSET__m5kF6JcW__"